import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let moduleEl = this.el
        let elmClass = 'is-active'
        let elmTargets = moduleEl.querySelectorAll('.-has-children > a')

        elmTargets.forEach((elm) => {
            let linkParent = elm.parentNode
            let linkParentClass = linkParent.classList
            let linkParentTitle = linkParent.querySelector('a > span').innerHTML
            let linkParentUrl = linkParent.querySelector('a').getAttribute('href')
            let submenu = linkParent.querySelector('.c-nav-submenu')
            if (linkParentUrl !== '' && linkParentUrl !== '#') {
                submenu.insertAdjacentHTML('afterbegin', `<li class="${linkParentClass[0]} -lvl-1"><a class="${linkParentClass[0].replace('_item', '_link')}" href="${linkParentUrl}"><span>${linkParentTitle}</span></a></li>`)
            }
            elm.addEventListener('click', (e) => {
                e.preventDefault()
                let linkParent = elm.parentNode
                linkParent.classList.toggle(elmClass)
                if (linkParent.classList.contains(elmClass)) {
                    let elmHeight = linkParent.querySelector('.c-nav-submenu').scrollHeight
                    linkParent.querySelector('.c-nav-submenu').style.height = elmHeight + 'px'
                    setTimeout(() => {
                        linkParent.parentNode.style.height = linkParent.parentNode.scrollHeight + 'px'
                    }, 300);
                } else {
                    linkParent.querySelector('.c-nav-submenu').style.height = 0
                    setTimeout(() => {
                        linkParent.parentNode.style.height = linkParent.parentNode.scrollHeight - linkParent.querySelector('.c-nav-submenu').scrollHeight + 'px'
                    }, 300);
                }
                // close other submenus
                let otherSubmenus = linkParent.parentNode.querySelectorAll('.-has-children')
                otherSubmenus.forEach((otherSubmenu) => {
                    if (otherSubmenu !== linkParent) {
                        otherSubmenu.classList.remove(elmClass)
                        otherSubmenu.querySelector('.c-nav-submenu').style.height = 0
                    }
                }
                )
            })
            // document.addEventListener('click', (e) => {
            //     if (!elm.contains(e.target)) {
            //         let linkParent = elm.parentNode
            //         linkParent.classList.remove(elmClass)
            //         linkParent.querySelector('.c-nav-submenu').style.height = 0
            //     }
            // })
        })
    }

    destroy() {
        super.destroy()
        elmTargets.forEach((elm) => {
            elm.removeEventListener('click')
        })
        document.removeEventListener('click')
    }
}